// extracted by mini-css-extract-plugin
export default {"root":"styles_root__sOQ9B","dragging-over":"styles_dragging-over__w91Lc","draggingOver":"styles_dragging-over__w91Lc","color":"styles_color__MbYqT"};